import React, { createContext, useState, useContext, useEffect } from "react";
import jwtAxios, { setLogoutFunction } from "../apiAxios/axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);



  // Load token from localStorage on initialization
  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      setToken(savedToken);
      setIsAuthenticated(true);

      const fetchUserData = async () => {
        try {
          const response = await jwtAxios.get("/users/profile");
          setUser(response.data);
          localStorage.setItem("user", JSON.stringify(response.data)); // Update localStorage with latest user data
        } catch (error) {
          console.error("Error fetching user profile:", error);
          logout(); // Call logout if fetching user profile fails
        }
      };

      fetchUserData();
    }else{
      setIsAuthenticated(false)
    }
  }, []);

  // Login function
  const login = async (email, password) => {
    try {
      const response = await jwtAxios.post("/users/login", { email, password });
      const { token, user } = response.data;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user)); // Assuming the API returns user info
      setToken(token);
      setUser(user);
      setIsAuthenticated(true);
    } catch (error) {
      console.error("Login failed:", error.message);
      throw new Error("Login failed. Please check your credentials.");
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
  };

  // Pass the logout function to jwtAxios
  useEffect(() => {
    setLogoutFunction(logout);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
